module.exports = __webpack_public_path__ + "static/media/eva.db79bd2a.png";